import { createLogic } from 'redux-logic'
import { map } from 'rxjs/operators'
import * as constants from '../constants'

export const getPropertySearchList = createLogic({
  type: constants.GET_PROPERTY_SEARCH_LIST.ACTION,
  processOptions: {
    successType: constants.GET_PROPERTY_SEARCH_LIST.FULFILLED,
    failType: constants.GET_PROPERTY_SEARCH_LIST.REJECTED
  },
  process({ http, action }) {
    const body = {
      'propertyListName': `${action.payload.data}`,
      'count': 12 // default is 10, returned from api
  }

  return http
    .post('/api/common/searchCriteria/getPropertyListSuggestions', { ...body })
    .pipe(map(http.getBody))
  }
})
